import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { ICall, MyCallsStore } from 'pages/Calls/MyCalls/types';

const initialState: MyCallsStore = {
  list: [],
  loading: false,
};

const reset: CaseReducer<MyCallsStore> = () => initialState;

const loading: CaseReducer<MyCallsStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const list: CaseReducer<MyCallsStore, PayloadAction<ICall[]>> = (state, action) => {
  state.list = action.payload;
};

export const myCallsSlice = createSlice({
  name: 'myCalls',
  initialState,
  reducers: {
    reset,
    loading,
    list,
  },
});

const { reset: setReset, loading: setLoading, list: setCalls } = myCallsSlice.actions;

export { setReset };

const setMyCalls =
  (myCalls: ICall[]): AppThunk =>
  dispatch => {
    dispatch(setCalls(myCalls || []));
  };

export const getMyCalls =
  (search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<ICall[]>('/api/timesheet/engineering_appointment/period-called/', { ...search })
      .then(({ data }) => {
        dispatch(setMyCalls(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };
